import { ThemeStyles } from '@honda-canada/design-system-react';
import css from '@styled-system/css';
const themeStyles = new ThemeStyles();
themeStyles.addBaseStyles('Container')(css({
    px: ['s', 's', '40px'],
}));
themeStyles.addBaseStyles('Header')(() => css({
    minHeight: '40px',
    alignItems: 'center',
    borderTop: '1px solid',
    borderTopColor: 'grey.3',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    borderWidth: '1px',
    borderTopStyle: 'none',
    borderColor: 'grey.2',
    borderBottomStyle: 'solid',
}));
themeStyles.addBaseStyles('Section')(() => css({
    display: 'flex',
    flexDirection: 'column',
    gap: 'm',
}));
themeStyles.addBaseStyles('TitleIcon')(() => css({
    width: '16px',
    height: '12px',
    marginRight: 'm',
}));
export default themeStyles;
